import classNames from "classnames";
import { useContext } from "react";

import { MapContext } from "components/Map/Map";

import { ReactComponent as LightPointer } from "./icons/light_pointer.svg";
import { ReactComponent as DarkPointer } from "./icons/dark_pointer.svg";

import styles from "./AnchoredDialog.module.scss";

export interface AnchoredDialogProps {
  dataQA: string;
  className?: string;
  children: React.ReactNode;
}

export default function AnchoredDialog({
  children,
  dataQA,
  className,
}: AnchoredDialogProps) {
  const { controlTheme } = useContext(MapContext);

  return (
    <div
      data-qa={dataQA}
      className={classNames(className, styles.container, styles[controlTheme])}
    >
      {children}
      <div className={styles.pointer}>
        {controlTheme === "light" ? <LightPointer /> : <DarkPointer />}
      </div>
    </div>
  );
}
